module.exports = __webpack_public_path__ + "img/header-memoireRingsGold.a59b5d1.webp";